import React, { useState } from 'react';
import { ActionList, Badge, Button, InlineStack, Popover } from '@shopify/polaris';
import { EditIcon } from '@shopify/polaris-icons';

export default function RentalStatusPill({ label, tone = 'info', editLabel, value, options, onChange, disabled = false, loading = false, children }) {
  const [editing, setEditing] = useState(false);

  return (
    <InlineStack gap="100" blockAlign="center" wrap={false}>
      <Badge tone={tone}>{label}</Badge>
      <Popover
        active={editing && !disabled && !loading}
        activator={(
          <Button
            icon={EditIcon}
            variant="plain"
            accessibilityLabel={editLabel}
            onClick={() => setEditing((open) => !open)}
            disabled={disabled}
            loading={loading}
          />
        )}
        onClose={() => setEditing(false)}
        autofocusTarget="first-node"
      >
        <ActionList
          items={options.map((option) => ({
            content: option.label,
            active: option.value === value,
            disabled: option.disabled || option.value === value,
            onAction: () => {
              setEditing(false);
              onChange(option.value);
            },
          }))}
        />
        {children && <Popover.Pane sectioned>{children}</Popover.Pane>}
      </Popover>
    </InlineStack>
  );
}
